import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
  View,
  ActivityIndicator,
  SafeAreaView,
  StyleSheet,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  BackHandler,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { CommonStyles, CommonProperties } from '../styles';
import { AA_ENABLED, EVENTS_ENABLED, REBOOK_ENABLED } from '../config/env';
import { Formik } from 'formik';
import { Screens } from '../constants/ScreenNames';
import { getCartView, getTravelCart, updatePassenger } from '../store/actions/search';

import * as Yup from 'yup';
import { birthDateMax, passportExpiryMax, newDateIfDefault } from '../utils/date.utils';
import i18n from 'i18next';
import CheckoutStepper from '../components/CheckoutStepper';
import FixedNextButtonBar from '../components/shared/FixedNextButtonBar';
import { Checkbox } from '../components/Checkbox';
import BaseText from '../components/BaseText';
import { useComponentTKey, i18nNS } from '../i18n';
import { selectTotalCartAmount } from '../store/selectors/cart.selector';
import { selectCheckoutStepperSteps, selectTripSummary } from '../store/selectors/trip.selector';
import TotalPrice from '../components/TotalPrice';
import { selectCheckedRebookPassengers } from '../store/selectors/mytrips.selector';
import PassengerDetailsComponentFormik from '../components/PassengerDetailsComponentFormik';
import RebookPassengerDetailsFormik from '../components/RebookPassengerDetailsFormik';
import { useTranslation } from 'react-i18next';
import { HeaderBackButton } from '@react-navigation/elements';
import { movePrevious } from '../store/actions/workflow';
import { selectedCarComponents } from '../store/selectors/car.selector';
import { selectedHotelComponents } from '../store/selectors/hotel.selector';
import { openAlert } from '../store/actions/alert';
import { setTravelerRefNumber, validateTravelerRefNumberForInfant } from '../utils/passenger.util';
import { aadvantageValidate } from '../store/actions/auth';
import {
  selectAadvantageNumber,
  selectCompanyCulture,
  selectTokenData,
} from '../store/selectors/auth.selector';
import { pageKeys } from '../constants/PageKeys';
import Messages from '../components/event/Messages';
import {
  selectTezEvent,
  selectTezEventGroup,
  selectTezEventPassengers,
} from '../store/selectors/events.selector';
import {
  getCustomFieldValidation,
  getReportingFields,
  getDeploymentMap,
} from '../utils/customFieldUtils';
import { selectUserProfile } from '../store/selectors/profile.selector';
import {
  selectAirComponents,
  selectedFlightComponents,
  selectAirportsCloud,
} from '../store/selectors/air.selector';
import {
  selectIsRedisKeyPresent,
  selectSearchInput,
  selectTripResults,
} from '../store/selectors/search.selector';
import { selectedHotelDetail } from '../store/selectors/hotel.selector';
import { containsInput } from '../utils/common.utils';
import { buildAirTravelComponentResponse } from '../utils/air.util';
import { searchTypesEnum } from '../constants/Enums';
const maxErrorString = '50 Char Limit';
const SOUTH_WEST_AIRLINES = 'WN';
const FRONTIER_AIRLINES = 'F9';
const SUN_COUNTRY_AIRLINES = 'SY';
const SPIRIT_AIRLINES = 'NK';
const SOUTHWESTAIRLINES = 'Southwest Airlines';
const FRONTIERAIRLINES = 'Frontier Airlines';
const SUNCOUNTRYAIRLINES = 'Sun Country';
const SPIRITAIRLINES = 'Spirit Airlines';
const MEMBER_KEYWORD = 'member';
// initializes loyalty for air, hotel and car
const initializeLoyalty = (loyalty, selectedComponent, type) => {
  if (loyalty === undefined || loyalty?.length == 0) {
    return selectedComponent?.map((component) => {
      const defaultLoyalty = {
        ProgramNumber: '',
        IsVisible: true,
      };
      type == searchTypesEnum.AIR
        ? ((defaultLoyalty.AirLineCode = component?.AirlineCode),
          (defaultLoyalty.AirlineName = component?.AirlineName))
        : type == searchTypesEnum.HOTEL
        ? ((defaultLoyalty.HotelChainCode = component?.HotelCode),
          (defaultLoyalty.HotelChainName = component?.ChainName))
        : ((defaultLoyalty.CarVendorCode = component?.VendorCode),
          (defaultLoyalty.CarVendorName = component?.VendorName));
      return defaultLoyalty;
    });
  } else {
    const result = loyalty?.filter((program) => program?.IsVisible);
    if (result === undefined || result.length == 0) {
      if (type == searchTypesEnum.AIR) {
        result?.push({
          AirlineCode: selectedComponent[0]?.AirlineCode,
          AirlineName: selectedComponent[0]?.AirlineName,
          ProgramNumber: '',
          IsVisible: true,
        });
      } else if (type == searchTypesEnum.HOTEL) {
        result?.push({
          HotelChainCode: selectedComponent[0]?.HotelCode,
          HotelChainName: selectedComponent[0]?.ChainName,
          ProgramNumber: '',
          IsVisible: true,
        });
      } else {
        result?.push({
          CarVendorCode: selectedComponent[0]?.VendorCode,
          CarVendorName: selectedComponent[0]?.VendorName,
          ProgramNumber: '',
          IsVisible: true,
        });
      }
    }
    return result;
  }
};

const PassengerScreen = (props) => {
  useLayoutEffect(() => {
    props.navigation.setOptions({
      headerLeft: (headerLeftProps) => (
        <HeaderBackButton {...headerLeftProps} onPress={() => dispatch(movePrevious())} />
      ),
    });
    function handleBackButton() {
      dispatch(movePrevious());
      return true;
    }

    BackHandler.addEventListener('hardwareBackPress', handleBackButton);
    return () => BackHandler.removeEventListener('hardwareBackPress', handleBackButton);
  }, [props.navigation, dispatch]);
  const isRedisCacheKeyPresent = useSelector(selectIsRedisKeyPresent);
  const hotelDetail = useSelector(selectedHotelDetail);
  const LowCostAirlinesArray = [
    SOUTH_WEST_AIRLINES,
    SPIRIT_AIRLINES,
    SUN_COUNTRY_AIRLINES,
    FRONTIER_AIRLINES,
  ];
  let selectedFlightCodes = [];
  let hasOnlyLowCostAirlinesPresent = false;
  let hasOnlyBasicBrands = false;
  let multiBrandResponseKeys = [];
  let matchedBrandValues = [];
  const BASIC = 'Basic';
  const LowCostAirlineNamesArray = [
    SOUTHWESTAIRLINES,
    SPIRITAIRLINES,
    SUNCOUNTRYAIRLINES,
    FRONTIERAIRLINES,
  ];
  const [isMemberRateHotel, setIsMemberRateHotel] = useState(false);
  useEffect(() => {
    if (hotelDetail) {
      const result = containsInput(hotelDetail.Description, MEMBER_KEYWORD);
      setIsMemberRateHotel(result);
    }
  }, [hotelDetail]);

  useEffect(() => {
    async function fetchCartView() {
      if (userProfile?.IsBookingAllowed || EVENTS_ENABLED || REBOOK_ENABLED) {
        let selectionData = { selectedCar };
        if (isRedisCacheKeyPresent) {
          const selectedAir = await buildAirTravelComponentResponse(
            selectedAirComponents,
            selectInput,
            airports
          );
          selectionData = { selectedCar, selectedAir };
        }
        await dispatch(getCartView(null, selectionData));
        await dispatch(getTravelCart(selectedHotel));
        setLoading(false);
      }
    }
    fetchCartView();
  }, [dispatch, selectedCar, selectedHotel]);

  const [loading, setLoading] = useState(true);
  const [includePriceInEmail, setIncludePriceInEmail] = useState(true);
  const dispatch = useDispatch();
  const tripSummary = useSelector(selectTripSummary);
  const checkoutSteps = useSelector(selectCheckoutStepperSteps);
  const travelCart = useSelector((state) => state.search && state.search.travelCart);
  const cartTotal = useSelector(selectTotalCartAmount);
  const selectedFlight = useSelector(selectedFlightComponents);
  const airports = useSelector(selectAirportsCloud);
  const selectedCar = useSelector(selectedCarComponents);
  const selectedHotel = useSelector(selectedHotelComponents);
  const selectedAirComponents = useSelector(selectAirComponents);
  const selectInput = useSelector(selectSearchInput);
  const aadvantageNo = useSelector(selectAadvantageNumber);
  const selectCompany = useSelector(selectCompanyCulture);
  const eventGroupKey = useSelector(selectTezEventGroup);
  const tezEvent = useSelector(selectTezEvent);
  const tokenData = useSelector(selectTokenData);
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('PassengerScreen');
  const passengers = useSelector(selectCheckedRebookPassengers);
  const userProfile = useSelector(selectUserProfile);
  const eventsMainPax = useSelector(selectTezEventPassengers)?.[0];
  const passengerList =
    EVENTS_ENABLED && travelCart?.Passengers && eventsMainPax
      ? travelCart?.Passengers?.map((pax, idx) => {
          const { FirstName, LastName, Gender, EmailAddress, BirthDate } = eventsMainPax;
          return idx === 0
            ? {
                ...pax,
                FirstName,
                LastName,
                Gender,
                EmailAddress,
                BirthDate,
              }
            : pax;
        })
      : travelCart?.Passengers;

  if (!EVENTS_ENABLED && !REBOOK_ENABLED && !userProfile?.IsBookingAllowed) {
    dispatch(
      openAlert({
        message: t(tKey('ContactTravelArranger')),
        confirmText: t(tKey('BackToSearch')),
        onConfirmPressed: () => props.navigation.navigate(Screens.Home),
      })
    );
  }
  if (travelCart?.IsAir) {
    if (selectedFlight[0]?.id) {
      selectedFlightCodes = selectedFlight?.flatMap((flight) =>
        flight?.legs?.flatMap((leg) => leg?.flights?.map((f) => f.marketting))
      );
      hasOnlyLowCostAirlinesPresent =
        selectedFlightCodes &&
        selectedFlightCodes?.length > 0 &&
        selectedFlightCodes?.every((airline) => LowCostAirlinesArray.includes(airline));
      if (selectedAirComponents && Object.keys(selectedAirComponents).length > 0) {
        multiBrandResponseKeys = Object.keys(selectedAirComponents)
          .filter((key) => 'newMultiBrandResponseKey' in selectedAirComponents[key])
          .map((key) => selectedAirComponents[key].newMultiBrandResponseKey);

        matchedBrandValues = selectedFlight
          .flatMap((flight) =>
            flight?.fares?.filter((fare) => multiBrandResponseKeys?.includes(fare.id))
          )
          .map((matchedFare) => matchedFare?.brand);
      }
      hasOnlyBasicBrands =
        matchedBrandValues && matchedBrandValues?.every((brand) => brand === BASIC);
    } else {
      selectedFlightCodes =
        selectedFlight &&
        selectedFlight
          ?.filter((flight) => flight?.AirlineName)
          .map((flight) => flight?.AirlineName);

      hasOnlyLowCostAirlinesPresent =
        selectedFlightCodes &&
        selectedFlightCodes?.length > 0 &&
        selectedFlightCodes?.every((airline) => LowCostAirlineNamesArray.includes(airline));

      matchedBrandValues = selectedFlight
        .filter(
          (flight) =>
            flight?.MultiBrands && flight.MultiBrands[0] && flight?.MultiBrands[0]?.LegBrandName
        )
        .map((flight) => flight?.MultiBrands[0]?.LegBrandName);

      hasOnlyBasicBrands =
        matchedBrandValues && matchedBrandValues?.every((brand) => brand === BASIC);
    }
  }
  const initializePassport = (passport) => {
    if (!passport) {
      return [
        {
          passportCountryCode: selectCompany || 'US',
          passportNumber: '',
          passportDate: '',
        },
        {
          passportCountryCode: selectCompany || 'US',
          passportNumber: '',
          passportDate: '',
        },
      ];
    } else {
      const passportArr = [];
      passport.map((data) => {
        const obj = {
          passportCountryCode: data?.PassportCountryCode,
          passportNumber: data?.PassportNumber,
          passportDate: newDateIfDefault(data?.PassportDate),
        };
        passportArr.push(obj);
      });
      return passportArr;
    }
  };

  const reportingFields = getReportingFields(travelCart?.ReportingFields, true);
  const filteredAirlineLoyalty = tripSummary?.FrequentFlyers?.filter(
    (program) => program.IsVisible
  );
  // deploymentMap is going to store the UDIDs displayed on this screen
  const deploymentMap = getDeploymentMap(reportingFields);

  //I am creating this object for adding it to every initial
  //object we have, without repeating code
  const customFieldsObject = {
    //ReportingFiels is required to store its values in redux later
    ReportingFields: reportingFields,
    customFields: reportingFields?.reduce(
      (object, field) => ({ ...object, [field.UDIDText]: '' }),
      {}
    ),
  };

  const passengerValidationSchema = Yup.lazy(() => {
    const passportDetailsValidation = Yup.object().shape({
      passportNumber: Yup.string(),
      passportDate: Yup.date().when('passportNumber', {
        is: (v) => v && v.length,
        then: Yup.date()
          .max(passportExpiryMax, 'Date too far in future')
          .min(new Date(), 'Date must be in ther future')
          .required(i18n.t('common:Error.invalidDate')),
      }),
    });

    const phoneRegex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

    const reportingFieldsValidation = Yup.object().shape(
      getCustomFieldValidation(reportingFields, Yup, deploymentMap)
    );

    const passengerValidation = Yup.object().shape({
      firstname: Yup.string()
        .max(50, maxErrorString)
        .required(i18n.t('common:Error.requiredFirstName'))
        .nullable()
        .trim(),
      lastname: Yup.string()
        .max(50, maxErrorString)
        .required(i18n.t('common:Error.requiredLastName'))
        .nullable()
        .trim(),
      middlename: Yup.string().max(50, maxErrorString).nullable(),
      suffix: Yup.string().max(50, maxErrorString).nullable(),
      email: Yup.string()
        .email(i18n.t('common:Error.invalidEmail'))
        .required(i18n.t('common:Error.requiredEmail'))
        .nullable()
        .trim(),
      gender: Yup.string().required(i18n.t('common:Error.requiredGender')).nullable(),
      associateTravelerRefNumber: REBOOK_ENABLED
        ? Yup.string().required(i18n.t('common:Error.selectAdultForInfant'))
        : null,
      birthdate: Yup.date()
        .min(birthDateMax, 'Date too far in the past')
        .max(new Date(), `You can't be born in the future!`)
        .required(i18n.t('common:Error.invalidBirthDate'))
        .nullable(),
      redressNumber: Yup.string().max(50, maxErrorString).nullable().trim(),
      knownTravellerNumber: Yup.string().max(50, maxErrorString).nullable().trim(),
      phone: Yup.string()
        .matches(phoneRegex, i18n.t('common:Error.invalidPhone'))
        .min(9, i18n.t('common:Error.invalidPhone'))
        .required(i18n.t('common:Error.requiredPhone'))
        .nullable()
        .trim(),
      PassportDetails: Yup.array().of(passportDetailsValidation).nullable(),
      customFields: reportingFieldsValidation,
      ...(isMemberRateHotel && {
        HotelLoyalty: Yup.array().of(
          Yup.object().shape({
            ProgramNumber: Yup.string().required('Hotel loyalty number is required'),
          })
        ),
      }),
    });

    return Yup.object().shape({
      passengers: Yup.array().of(passengerValidation),
    });
  });
  const defaultPassengerDetailsInitialValues = {
    loyalty: {
      airLoyalty: filteredAirlineLoyalty?.length
        ? filteredAirlineLoyalty.map((program) => {
            return {
              ...program,
            };
          })
        : [
            {
              AirLineCode: selectedFlight[0]?.AirlineCode,
              AirLineName: selectedFlight[0]?.AirlineName,
              ProgramNo: '',
              IsVisible: true,
            },
          ],

      hotelLoyalty: tripSummary?.HotelLoyaltys?.length
        ? tripSummary.HotelLoyaltys.map((program) => {
            return {
              ...program,
            };
          })
        : [
            {
              HotelChainCode: selectedHotel[0]?.HotelCode,
              HotelChainName: selectedHotel[0]?.ChainName,
              PreferenceNo: '',
              ProgramNumber: '',
              IsVisible: true,
            },
          ],
      carLoyalty: tripSummary?.CarLoyaltys?.length
        ? tripSummary.CarLoyaltys.map((program) => {
            return {
              ...program,
            };
          })
        : [
            {
              CarVendorCode: selectedCar[0]?.VendorCode,
              CarVendorName: selectedCar[0]?.VendorName,
              PreferenceNo: '',
              ProgramNumber: '',
              IsVisible: true,
            },
          ],
      railLoyalty: tripSummary?.RailLoyaltys?.length
        ? tripSummary.RailLoyaltys.map((program) => {
            return {
              ...program,
            };
          })
        : [
            {
              RailVendorCode: '',
              RailVendorName: '',
              PreferenceNo: '',
              ProgramNumber: '',
            },
          ],
    },
    IncludePriceInEmail: includePriceInEmail,
    passengers: passengerList?.map((passenger, index) => {
      if (index == 0) {
        return {
          firstname: passenger?.FirstName,
          middlename: passenger?.MiddleName,
          lastname: passenger?.LastName,
          suffix: '',
          gender: passenger?.Gender,
          email: passenger?.EmailAddress,
          phone: passenger?.Phone,
          birthdate: passenger?.BirthDate && new Date(passenger?.BirthDate),
          redressNumber: passenger?.RedressNumber,
          knownTravellerNumber: passenger?.KnownTravellerNumber,
          knownTravellerNumberCountryCode: passenger?.KnownTravellerNumberCountryCode || 'US',
          associateTravelerRefNumber: setTravelerRefNumber(passenger),
          phoneCountryCode: passenger?.PhoneCountryCode || 'US',
          IsExcludePricingInfo: true,
          FrequentFlyers: initializeLoyalty(
            tripSummary?.FrequentFlyers,
            selectedFlight,
            searchTypesEnum.AIR
          ),
          CarLoyalty: initializeLoyalty(tripSummary?.CarLoyaltys, selectedCar, searchTypesEnum.CAR),

          HotelLoyalty: initializeLoyalty(
            tripSummary?.HotelLoyaltys,
            selectedHotel,
            searchTypesEnum.HOTEL
          ),
          PassportDetails: initializePassport(travelCart?.Passengers[index]?.PassportDetails),
          ...customFieldsObject,
        };
      } else {
        return {
          firstname: '',
          middlename: '',
          lastname: '',
          suffix: '',
          gender: '',
          email: '',
          phone: '',
          birthdate: '',
          redressNumber: '',
          knownTravellerNumber: '',
          knownTravellerNumberCountryCode:
            passengerList[0]?.KnownTravellerNumberCountryCode || 'US',
          associateTravelerRefNumber: setTravelerRefNumber(passenger),
          phoneCountryCode: passengerList[0]?.PhoneCountryCode || 'US',
          IsExcludePricingInfo: true,
          FrequentFlyers: initializeLoyalty(
            tripSummary?.FrequentFlyers,
            selectedFlight,
            searchTypesEnum.AIR
          ),
          HotelLoyalty: initializeLoyalty(
            tripSummary?.HotelLoyaltys,
            selectedHotel,
            searchTypesEnum.HOTEL
          ),
          CarLoyalty: initializeLoyalty(tripSummary?.CarLoyaltys, selectedCar, searchTypesEnum.CAR),
          PassportDetails: initializePassport(travelCart?.Passengers[index]?.PassportDetails),
          ...customFieldsObject,
        };
      }
    }),
  };
  const rebookInitialValues = {
    loyalty: {
      airLoyalty: tripSummary?.FrequentFlyers?.length
        ? tripSummary.FrequentFlyers.map((program) => {
            return {
              ...program,
            };
          })
        : [
            {
              AirLineCode: '',
              AirLineName: '',
              ProgramNo: '',
            },
          ],
    },
    IncludePriceInEmail: includePriceInEmail,
    passengers: passengers?.map((passenger, index) => {
      return {
        title: passenger.Title || '',
        firstname: passenger.FirstName || '',
        middlename: passenger.MiddeleName || '',
        lastname: passenger.LastName || '',
        suffix: '',
        gender: passenger.Gender || '',
        email: passenger.EmailAddress || '',
        phone: passenger.Phone || '',
        birthdate:
          (passenger.BirthDate && new Date(passenger.BirthDate)) || new Date(passenger.DOB),
        redressNumber: passenger.RedressNumber || '',
        knownTravellerNumber: passenger.KnownTravellerNumber || '',
        knownTravellerNumberCountryCode: passenger.KnownTravellerNumberCountryCode || 'US',
        phoneCountryCode: passenger.PhoneCountryCode || 'US',
        associateTravelerRefNumber: setTravelerRefNumber(passenger),
        isInfantSeat: passenger.PassengerType === 'INS' ? true : false,
        ...customFieldsObject,
      };
    }),
  };
  return (
    <SafeAreaView style={CommonStyles.defaultContainer}>
      <Messages
        companyKey={EVENTS_ENABLED ? tezEvent?.CompanyKey : tokenData?.companyKey}
        groupKey={EVENTS_ENABLED ? eventGroupKey : tokenData?.groupKey}
        pageKey={pageKeys.PASSENGER_DETAILS}
      />
      {loading ? (
        <View style={[CommonStyles.flex1, CommonStyles.centerAlignment]}>
          <ActivityIndicator size="small" />
        </View>
      ) : (
        <Formik
          enableReinitialize={false}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={passengerValidationSchema}
          initialValues={
            REBOOK_ENABLED ? rebookInitialValues : defaultPassengerDetailsInitialValues
          }
          onSubmit={(values) => {
            let valid = true;
            if (REBOOK_ENABLED) {
              valid = validateTravelerRefNumberForInfant(values.passengers);
            }
            if (!valid) {
              dispatch(openAlert({ message: 'Infant should have unique associate' }));
            } else {
              dispatch(updatePassenger(values, deploymentMap));
              if (travelCart.IsAir) {
                if (hasOnlyBasicBrands || hasOnlyLowCostAirlinesPresent) {
                  props.navigation.navigate(Screens.Purchase);
                } else {
                  props.navigation.navigate(Screens.Seat);
                }
              } else {
                props.navigation.navigate(Screens.Purchase);
              }
            }
          }}
        >
          {(formProps) => {
            return (
              <KeyboardAvoidingView
                behavior={Platform?.OS === 'ios' ? 'padding' : ''}
                style={CommonStyles.flex1}
              >
                <ScrollView style={styles.scrollContainer}>
                  <CheckoutStepper
                    entities={checkoutSteps}
                    isTouchable={false}
                    flowDepth={0}
                    crumbsContainerStyle={styles.stepperContainer}
                  />
                  <TotalPrice
                    response={tripSummary}
                    value={cartTotal}
                    navigation={props.navigation}
                  />
                  {REBOOK_ENABLED ? (
                    <RebookPassengerDetailsFormik travelCart={travelCart} formProps={formProps} />
                  ) : (
                    <PassengerDetailsComponentFormik
                      formProps={formProps}
                      deploymentMap={deploymentMap}
                    />
                  )}
                </ScrollView>
                <FixedNextButtonBar
                  onPress={formProps.handleSubmit}
                  cartTotal={cartTotal}
                  response={tripSummary}
                />
              </KeyboardAvoidingView>
            );
          }}
        </Formik>
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  scrollContainer: {
    flex: 1,
    ...CommonProperties.px3,
  },
  stepperContainer: {
    ...CommonProperties.mb2,
    ...CommonProperties.mt3,
  },
});
export default PassengerScreen;
